export const SURVEY_ENABLED = false; // flip to false to disable survey everywhere
export const SURVEY_URL = "https://tally.so/r/J9L9Y4";
export const SURVEY_CLOSED_KEY = "surveyClosed"; // change key for each new survey
